import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

/**
 * Requires a boolean field to be explicitly `true` (e.g. an acceptance checkbox).
 * Mirrors the backend MustBeTrueValidationRuleResolver.
 */
export const mustBeTrueValidationRuleResolver: BaseValidationRuleResolver = (value) => {
  return value === true ? null : 'Required';
};
